import { styled } from '@linaria/react';
import { bodyFont, colors, fonts, space } from '../../theme/tokens';

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SelectedInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
`;

export const QuantityText = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.xs};
  color: ${colors.fontSecondary};
`;
